/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import Header from './Header';
import Body from './Body';
import  './index.css'
import BodyHeader from './BodyHeader';
import { useDispatch, useSelector } from 'react-redux';
import { authorized } from '../../../store/actions/alert.actions'
import BodyContainer from './BodyContainer';
import BodyFullContainer from './BodyFullContainer';

const Module = ({ children, moduleName }) => {
  const permissions = useSelector(state => state?.auth?.permissions || {})
  const dispatch = useDispatch()

  useEffect(() => {
    if (moduleName) {
      dispatch(authorized(moduleName, permissions))
    }
  }, [moduleName])

  return (
    <div className='py-2 px-2 h-screen-module w-full'>
      <div className='h-full w-full overflow-hidden bg-background rounded shadow'>{children}</div>
    </div>
  )
}

Module.Header = Header;
Module.Body = Body;
Module.BodyHeader = BodyHeader;
Module.BodyFullContainer = BodyFullContainer;
Module.BodyContainer = BodyContainer;

export default Module